import { render, staticRenderFns } from "./user-certify.vue?vue&type=template&id=f2af0518&scoped=true&"
import script from "./user-certify.vue?vue&type=script&lang=js&"
export * from "./user-certify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af0518",
  null
  
)

export default component.exports